module.exports = __webpack_public_path__ + "static/media/butt.a24c736c.svg";